import templateUrl from "emun.order/notes/note-prompt.htm";
import NotePromptController from "emun.order/notes/note-prompt.controller";
import modals from "webmodals/modals";

const resolve = () => null;
const reject = reason => console.warn('reject reason', reason);

const NotePrompt = {
  open(options) {
    const prom = modals.open(Object.assign({
      size: 'lg quick-report-prompt',
      templateUrl,
      resolve: {
        options: () => options
      },
      bindToController: true,
		controller: NotePromptController,
      controllerAs: '$ctrl'
    }, (options || {}).modal)).result;

    prom.then(resolve, reject);

    return prom;
  }
};

export default NotePrompt;
